<main class="hero-banner" id="banner-home">
  <div class="container">
    <div class="image-container">
      <img 
        [src]="currentLogoUrl" 
        [alt]="bannerData.logo.alt" 
        width="180"
        height="150"
        loading="eager"
        decoding="async"
        class="banner-image logo-animating"
        [class.anniversary-emphasis]="isAnniversaryLogo"
        [attr.data-animation-key]="animationKey" />
    </div>

    <div class="text-content">
      <h1 class="title">
        {{ bannerData.content.title }}
        <span class="text-highlight">{{ bannerData.content.highlightedTitle }}</span>
      </h1>

      <p class="description">{{ bannerData.content.description }}</p>
    </div>

    <div class="button-section">
      <div>
        <app-button
          [text]="bannerData.buttons.projects"
          backgroundColor="#6495B5"
          textColor="#FFFFFF"
          (clicked)="goToProjects()">
        </app-button>
      </div>
      <div>
        <app-button
          [text]="bannerData.buttons.trajectory"
          backgroundColor="#FFFFFF"
          textColor="#6495B5"
          (clicked)="goToTrayectoria()">
        </app-button>
      </div>
    </div>
  </div>
  <app-stats></app-stats>
</main>
